import { KeyValuePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TuiButton, TuiDropdown, TuiIcon } from '@taiga-ui/core';
import { MenuAction } from 'src/app/shared/models/menu-actions/menu-action';

@Component({
  selector: 'pxc-dropdown-button',
  templateUrl: './dropdown-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TuiButton, TuiDropdown, TuiIcon, KeyValuePipe, NgClass],
})
export class DropdownButtonComponent {
  @Input() icon?: string;
  @Input() appearance?: string;
  @Input() actions: { [key: string]: MenuAction };
  @Input() selectedKey: string;

  open = false;

  onClick(action: MenuAction): void {
    action.execute();
    this.open = false;
  }
}
